import * as React from 'react';
import { memo, useCallback } from 'react';

import { PopupNames } from 'core';
import { IPaletteAgreement } from 'core/state';
import { usePopupData, usePopupStateOperations } from 'core/hooks';
import { MoveToGroupInlinePopup } from 'pages/_detailShared/MoveToGroupInlinePopup';

/** popupData shape for the palette-dispatched «move to group» popup. */
export interface IMoveToGroupPopupData {
  studentId: string;
  agreement: IPaletteAgreement;
}

/**
 * Registry wrapper for the self-contained `MoveToGroupInlinePopup` (which owns
 * `useChangeAgreementGroup`), dispatched by the palette via
 * `showPopup(PopupNames.moveToGroupPopup, { studentId, agreement })`.
 */
export const MoveToGroupPopup = memo(() => {
  const data = usePopupData(PopupNames.moveToGroupPopup);
  const {
    operations: { hidePopup },
  } = usePopupStateOperations();

  const close = useCallback(() => hidePopup(PopupNames.moveToGroupPopup), [
    hidePopup,
  ]);

  if (!data) return null;

  return (
    <MoveToGroupInlinePopup
      agreement={data.agreement}
      studentId={data.studentId}
      onClose={close}
    />
  );
});
